import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100",
  height: "100",
  viewBox: "0 0 70 70",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "35",
  cy: "35",
  r: "35",
  fill: "url(#paint0_linear_106_2323)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "35",
  cy: "35",
  r: "31",
  fill: "#262626"
}, null, -1)
const _hoisted_4 = {
  x: "50%",
  y: "45%",
  "text-anchor": "middle",
  "alignment-baseline": "middle",
  fill: "white",
  "font-size": "15"
}
const _hoisted_5 = {
  x: "50%",
  y: "65%",
  "text-anchor": "middle",
  "alignment-baseline": "middle",
  fill: "white",
  "font-size": "9"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "paint0_linear_106_2323",
    x1: "35",
    y1: "0",
    x2: "35",
    y2: "70",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#60A5FA" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#8B5DF1"
    })
  ])
], -1)




export default /*#__PURE__*/_defineComponent({
  __name: 'StatsButtonMenu',
  props: {
    text1: {},
    text2: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("text", _hoisted_4, _toDisplayString(props.text1), 1),
    _createElementVNode("text", _hoisted_5, _toDisplayString(props.text2), 1),
    _hoisted_6
  ]))
}
}

})